<template>
    <div class="col-sm-6 col-md-4">
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
    </div>
</template>

<script>
    export default {

    };
</script>

<style scoped>

</style>